const initialState = {
    nomCategories: [],
  };
  export default function (state = initialState, action) {
    switch (action.type) {
      case "NOMCATEGORIE_SELECT":
        return {
          ...state,
          nomCategories: action.payload,
        };
      default:
        return state;
    }
  }
  